<template>
    <div>
        <Card>
            <div class="search-con search-con-top">
                <Form :model="form" :label-width="80" inline>
                    <FormItem label="租户">
                      <Select v-model="form.tenantName" clearable>
                        <Option :value="item.id" v-for="(item, index) in tenantOptions" :key="index">{{item.name}}</Option>
                      </Select>
                    </FormItem>
                </Form>
                <div  class="toolbar">
                    <Button type="primary" icon="md-add" @click="handleCreate">新增</Button>
                    <Button type="primary" icon="md-trash" @click="handleDelete">删除</Button>
                   <Button @click="handleSearch" icon="md-search" class="search-btn" type="primary">搜索 </Button>
                </div>
            </div>
            <Tables ref="tables" v-model="tableData" :columns="columns" @on-search="handleSearch"
                    @on-update="handleUpdate" @on-detail="handleDetail" @on-selection-change="selectionChange"/>
        </Card>
        <tenantauthInfo ref="tenantauthInfoRef"  @handle-search="handleSearch"></tenantauthInfo>
    </div>
</template>

<script>
import tenantauthInfo from './tenantauth-info'
import { getIds } from '@/libs/util'

export default {
  name: 'tenantauth-list',
  components: {
    tenantauthInfo
  },
  data () {
    return {
      columns: [
        {
          title: ' ',
          key: 'id',
          width: 60,
          align: 'center',
          render: (h, params) => {
            let id = params.row.id
            let flag = false
            if (this.currentChoose === id) {
              flag = true
            }
            let self = this
            return h('div', [
              h('checkbox', {
                props: {
                  value: flag
                },
                on: {
                  'on-change': () => {
                    self.selectedData = []
                    self.currentChoose = id
                    self.selectedData.push(params.row)
                  }
                }
              })
            ])
          }
        },
        { title: '租户名称',
          key: 'tenantName',
          render: (h, params) => {
            return h('span', this.getTenantName(params.row.tenantName))
          }
        },
        { title: 'token', key: 'tokenId' },
        { title: '备注信息', key: 'memo' },
        { title: '创建时间', key: 'crtTime' },
        { title: '修改人', key: 'mdfUserId' },
        { title: '修改时间', key: 'mdfTime' },
        {
          title: '操作',
          key: 'handle',
          minWidth: 200,
          options: ['update', 'detail']
        }
      ],
      tableData: {
        rows: [],
        total: 0
      },
      form: {
        map: {}
      },
      tenantOptions: {},
      selectedData: [],
      currentChoose: '',
      infoIsShow: false
    }
  },
  methods: {
    handleUpdate (param) {
      this.$refs.tenantauthInfoRef.openModel('update', param.row)
    },
    handleDetail (param) {
      this.$refs.tenantauthInfoRef.openModel('detail', param.row)
    },
    handleCreate () {
      this.$refs.tenantauthInfoRef.openModel('create')
    },
    handleDelete () {
      this.D('admin/tenantauth', getIds(this.selectedData)).then(data => {
        this.$Message.success(data)
        this.handleSearch()
      })
    },
    selectionChange (selection) {
      this.selectedData = selection
    },
    getTenantName (tenantId) {
      let jsonArray = this.tenantOptions
      for (var key in jsonArray) {
        if (jsonArray[key].id === tenantId) {
          return jsonArray[key].name
        }
      }
    },
    handleSearch (page, pageSize) {
      if (isNaN(page)) {
        page = 1
      }
      var param = {
        page: page,
        pageSize: pageSize,
        model: this.form,
        map: this.form.map
      }
      this.L('admin/tenantauth', param).then(data => {
        this.tableData = data
      })
    }
  },
  mounted () {
    this.G('admin/tenant/getTenantByTenant').then(data => {
      this.tenantOptions = data
    })
    this.handleSearch()
  }
}
</script>
